import { Modal, notification, Typography } from 'antd';
import dayjs from 'dayjs';
import type { InternalNamePath } from '@/types/antd';
import { DATE_FORMAT } from '@/std/const/date';
import { type Result, attempt } from '@/std/result';
import { isDate } from '@/std/validate';

// oxlint-disable-next-line no-unused-vars
export function unreachable(_: never): never {
    throw new Error('Unreachable');
}

export function uuid(): string {
    return window.crypto.randomUUID();
}

export function changeFavIcon(href: string): void {
    document.getElementById('favicon')?.setAttribute('href', href);
}

export function copyTextToClipboard(text: string): Promise<Result<void>> {
    return attempt(navigator.clipboard.writeText(text));
}

export function openNewTab(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
}

export function getEnumText(
    someEnum: Record<string | number, number | string>,
    enumNumber: number,
): string {
    const enumKey = Object.keys(someEnum).find((key) => someEnum[key] === enumNumber);
    return enumKey || '';
}

export function sortColumn<T>(a: T, b: T, field: string): number {
    const field1 = a[field];
    const field2 = b[field];

    if (typeof field1 === 'string' && typeof field2 === 'string') {
        if (isDate(field1) && isDate(field2)) {
            if (field1 === field2) {
                return 0;
            }

            const data1 = dayjs(field1, DATE_FORMAT);
            const data2 = dayjs(field2, DATE_FORMAT);

            return data1.unix() - data2.unix() < 0 ? -1 : 1;
        }

        return field1.localeCompare(field2);
    }

    if (typeof field1 === 'number' && typeof field2 === 'number') {
        return field1 - field2;
    }

    return 0;
}

export function messageErrorRequiredFields(
    errors: {
        name?: InternalNamePath;
        errors: string[];
    }[],
): void {
    const style = {
        color: '#f5222e',
        fontFamily: 'SimSun, sans-serif',
    };

    const fields = errors.map((field) => field.errors[0] || '');

    Modal.error({
        content: (
            <div className='text-justify'>
                <Typography.Text>
                    Os campos sinalizados com ( <Typography.Text style={style}>*</Typography.Text> )
                    são obrigatórios, e os destacados em ({' '}
                    <Typography.Text style={style}>vermelho</Typography.Text> ) necessitam atenção.
                    Verifique para continuar.
                </Typography.Text>

                <p className='mt-3 font-bold'>Erros:</p>

                {fields.map((field) => (
                    <li key={uuid()}>
                        <div className='font-bold'>{field}</div>
                    </li>
                ))}
            </div>
        ),
        title: 'Falha na validação dos campos obrigatórios',
        zIndex: 1500,
    });
}

export function tableRowZebra(_, index: number): string {
    return index % 2 === 0 ? 'bg-gray-200' : '';
}

export function todo(description: string): void {
    notification.info({
        description,
        title: 'TODO',
    });
}
